function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.995 22.013A10.002 10.002 0 014.399 5.502H1.001a.499.499 0 010-.998h4.5A.5.5 0 016 5.003v4.5a.499.499 0 11-.998.003V6.349a8.998 8.998 0 006.993 14.665 8.983 8.983 0 004.852-1.423.499.499 0 01.27-.08.5.5 0 01.272.921 9.986 9.986 0 01-5.393 1.582zM22.999 19.502h-4.5a.5.5 0 01-.499-.499v-4.5a.499.499 0 01.998 0v3.162A9 9 0 007.204 4.386a.488.488 0 01-.267.077.498.498 0 01-.265-.921 9.996 9.996 0 0112.929 14.959h3.396a.5.5 0 010 1.001h.002z"
});

function SvgFormRefresh(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default __webpack_public_path__ + "formRefresh.98179.svg";
export { SvgFormRefresh as ReactComponent };